import type { StoreState } from '../../state-types';

/**
 * Make the survey dirty. This is used as a companion with the actions that should cause the survey dirty.
 * - By switching `isSurveyDirty` to true
 * - By switching `isCoreQuestionFormDirty` to true
 */
export const makeSurveyDirty = (state: StoreState): StoreState => ({
    ...state,
    ui: {
        ...state.ui,
        isSurveyDirty: true,
    },
    uiCoreQuestionForm: {
        ...state.uiCoreQuestionForm,
        isDirty: true,
    },
});
